import { render, staticRenderFns } from "./DefaultTemplates.vue?vue&type=template&id=5d2629a3&scoped=true"
import script from "./DefaultTemplates.vue?vue&type=script&lang=js"
export * from "./DefaultTemplates.vue?vue&type=script&lang=js"
import style0 from "./DefaultTemplates.vue?vue&type=style&index=0&id=5d2629a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2629a3",
  null
  
)

export default component.exports